import { styled } from '@mui/styles';
import { Container } from '@mui/material';

export const StyledContainer = styled(Container)(({ theme }) => ({
  position: 'relative',
  maxWidth: 970,
  margin: '40px auto',
  paddingLeft: 24,
  paddingRight: 24,

  [theme.breakpoints.down('sm')]: {
    marginTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
